// Compact human-readable byte size: 0 B, 512 B, 1.2 KB, 3.4 MB.
//
// Used for chat composer pills (e.g. file attachments, pasted-document
// artefacts). Other surfaces in the app still inline `Math.round(x / 1024)`
// when they only ever deal with KB-scale resumes — no migration required here.

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
  if (bytes < 1024) return `${Math.round(bytes)} B`;
  if (bytes < 1024 * 1024) {
    const kb = bytes / 1024;
    return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} KB`;
  }
  const mb = bytes / (1024 * 1024);
  return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`;
}
